import {
  ActivityScheduleSessionBlockReason,
  IActivityScheduleSessionBlockBase,
} from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateActivityScheduleSessionBlocksServiceProps {
  activityId: string;
  activityScheduleIds: string[];
  blockedDate: string;
  customReason?: string | null;
  reason: ActivityScheduleSessionBlockReason;
}

type Response = IActivityScheduleSessionBlockBase;

export async function createActivityScheduleSessionBlocksService({
  activityId,
  activityScheduleIds,
  blockedDate,
  customReason,
  reason,
}: ICreateActivityScheduleSessionBlocksServiceProps): Promise<Response> {
  const { data } = await jhsfBookingsApi.post(
    `/activities/${activityId}/session-blocks`,
    {
      activityScheduleIds,
      blockedDate,
      customReason,
      reason,
    },
  );

  return data;
}
